import { render, staticRenderFns } from "./SupplierQuality.vue?vue&type=template&id=2fb44fae&scoped=true"
import script from "./SupplierQuality.vue?vue&type=script&lang=js"
export * from "./SupplierQuality.vue?vue&type=script&lang=js"
import style0 from "./SupplierQuality.vue?vue&type=style&index=0&id=2fb44fae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb44fae",
  null
  
)

export default component.exports